// extracted by mini-css-extract-plugin
export default {"add-activations-form-content__btn":"addActivationDrawer_add-activations-form-content__btn__HkyTU"};